import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Brand} from '@vio/core/src/brand/types'
import {BrandLogo} from '@vio/shared/src/whiteLabel/BrandLogo'

interface Props {
  brand: Brand
}

export const FooterCopyrightSection = ({brand}: Props) => {
  const currentYear = new Date().getFullYear()
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <div>
        <BrandLogo brand={brand} height={24} isInverse />
      </div>
      <div className="chromatic-ignore">
        © {currentYear} {brand.name}
      </div>
    </Box>
  )
}
